import React from 'react';
import './TextBlock.css';
import TextFill from './TextFill';
import TextLink from './TextLink';
import {
	getHoverProps,
	getMarginStyle,
	getPaddingStyle,
	getTextStyle,
	getUnderlineClass,
} from '../styles';
import { ComponentSettings, TypographySettings } from '../../../types';

interface TextBlockProps {
	settings: ComponentSettings;
	text: TypographySettings;
	/** Admin preview: links do not navigate. */
	isPreview?: boolean;
}

/** A single line of text before the headline. Variants: plain, badge. */
const TextBlock: React.FC< TextBlockProps > = ( {
	settings,
	text,
	isPreview,
} ) => {
	if ( ! text.isVisible || ! text.text ) {
		return null;
	}

	const { style } = settings;
	const isBadge = settings.variant === 'badge';
	const hover = getHoverProps( style, [ 'hoverText', 'hoverBg' ] );

	return (
		<p
			className={ `sb-text is-${ settings.variant }${
				hover.className
			}${ getUnderlineClass( style.linkUnderline ) }` }
			style={ {
				...getTextStyle( text ),
				...getPaddingStyle( style ),
				...getMarginStyle( style ),
				...hover.style,
				...( isBadge
					? {
							backgroundColor: style.bgColor,
							borderRadius: style.radius
								? `${ style.radius }px`
								: undefined,
					  }
					: {} ),
			} }
		>
			<TextFill text={ text }>
				<TextLink text={ text } isPreview={ isPreview } />
			</TextFill>
		</p>
	);
};

export default TextBlock;
